import React, {FC} from "react"

import id from "@irati/utils/id"
import userBackgroundColor from "@irati/utils/userBackgroundColor"
import {Avatar} from "@irati/ui/src/Typography"

import {Pic} from "./styled"

interface Props {
  firstname?: string
  lastname?: string
  size?: number
  deactivated?: boolean
  border?: boolean
  id?: string
  marginRight?: boolean
}

const DefaultProfilePicture: FC<Props> = ({firstname = "", lastname = "", size, ...props}) => {
  const {deactivated, border, marginRight} = props
  const idNamespace = id("default-profile-picture", props)

  const firstNameInitial = firstname ? firstname.charAt(0).toUpperCase() : ""
  const lastNameInitial = lastname ? lastname.charAt(0).toUpperCase() : ""
  const initials = `${firstNameInitial}${lastNameInitial}`

  const getTypographySize = () => {
    if (size) {
      if (size <= 30) return {small: true}
      else if (size <= 50) return {regular: true}
      else if (size >= 100) return {large: true}
    }
    return undefined
  }

  return (
    <Pic id={idNamespace} size={size} border={border} color={userBackgroundColor(firstname, deactivated)} marginRight={marginRight}>
      <Avatar id={id("title", idNamespace)} {...getTypographySize()}>
        {initials}
      </Avatar>
    </Pic>
  )
}

export default DefaultProfilePicture
